export default {
  init() {
      $('select[name="activites"]').on('change', function(event) {
          event.preventDefault();
          var $lazy_btn = $(this);
          var activite_id = $(this).find('option:selected').val();

          if( activite_id.length === '' ){
              activite_id = null;
          }

          // $(this).parent().next().find('.ajax-loader').show();
          // $(this).parent().next().find('select').addClass('loading');

          $.ajax({
              url: ajaxurl,
              type: 'POST',
              dataType: 'JSON',
              data: { activite_id: activite_id, action: 'search_activities' }
          })
          .done(function(response) {
              $('.searchbus-form select#lignes').parent().next().find('.ajax-loader').hide();
              $('.searchbus-form select#lignes').parent().next().find('select').removeClass('loading');
              if( response && response.html != "" ){
                  $('select[name="children_activites"]').empty().append(response.html);
              }
          })
          .fail(function() {
              $('.searchbus-form select#lignes').parent().next().find('.ajax-loader').hide();
              $('.searchbus-form select#lignes').parent().next().find('select').removeClass('loading');
          })
          .always(function() {
              $('.searchbus-form select#lignes').parent().next().find('select').removeClass('loading');
          });

      });

      $(window).on('load', function(event) {
          // var $lazy_btn = $(this);
          var activite_id = $('select[name="activites"]').find('option:selected').val();

          if( activite_id.length === '' ){
              activite_id = null;
          }


          // $(this).parent().next().find('.ajax-loader').show();
          // $(this).parent().next().find('select').addClass('loading');

          $.ajax({
              url: ajaxurl,
              type: 'POST',
              dataType: 'JSON',
              data: { activite_id: activite_id, action: 'search_activities' }
          })
              .done(function(response) {
                  $('.searchbus-form select#lignes').parent().next().find('.ajax-loader').hide();
                  $('.searchbus-form select#lignes').parent().next().find('select').removeClass('loading');
                  if( response && response.html != "" ){
                      $('select[name="children_activites"]').empty().append(response.html);
                  }
              })
              .fail(function() {
                  $('.searchbus-form select#lignes').parent().next().find('.ajax-loader').hide();
                  $('.searchbus-form select#lignes').parent().next().find('select').removeClass('loading');
              })
              .always(function() {
                  $('.searchbus-form select#lignes').parent().next().find('select').removeClass('loading');
              });

      });
  },
  finalize() {


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateExposantsNouveautes.js